<a href="/" [class]="customHrefClass" (window:resize)="onResize()">
    <img
        alt="Logo"
        *ngIf="!appSession.tenant || !appSession.tenant.logoId"
        [src]="defaultLogo"
        class="h-25px app-sidebar-logo-default"
    />
    <img
        alt="Logo"
        *ngIf="!appSession.tenant || !appSession.tenant.logoId"
        [src]="defaultSmallLogo"
        class="h-20px app-sidebar-logo-minimize"
    />
    <img
        alt="Logo"
        *ngIf="appSession.tenant && appSession.tenant.logoId"
        [src]="
            remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=' +
            currentTheme.baseSettings.menu.asideSkin +
            '&tenantId=' +
            appSession.tenant.id +
            '&id=' +
            appSession.tenant.logoId
        "
        class="h-25px app-sidebar-logo-default"
    />
    <img
        alt="Logo"
        *ngIf="appSession.tenant && appSession.tenant.logoId"
        [src]="
            remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=' +
            currentTheme.baseSettings.menu.asideSkin +
            '&tenantId=' +
            appSession.tenant.id +
            '&id=' +
            appSession.tenant.logoId
        "
        class="h-20px app-sidebar-logo-minimize"
    />
</a>
